import React, { useState, useEffect } from 'react';
import { CustomHeaderProps } from 'ag-grid-react';
import TabLabelIcon from '@/components/TabLabel/TabLabelIcon';
import TooltipComponent from '@/components/UI/Tooltip/TooltipComponent';
import { ASC_ORDER, DESC_ORDER } from '@/helpers/constants';
import styles from './HeaderWithTooltip.module.scss';

interface HeaderWithTooltipProps extends CustomHeaderProps {
  tooltipText: string;
  isWarningTooltip?: boolean;
}

const HeaderWithTooltip: React.FC<HeaderWithTooltipProps> = (props) => {
  const { displayName, enableSorting, column, progressSort, tooltipText, api, isWarningTooltip = true } = props;
  const [sortDirection, setSortDirection] = useState(column.getSort());

  useEffect(() => {
    const onSortChanged = () => {
      setSortDirection(column.getSort());
    };

    api.addEventListener('sortChanged', onSortChanged);

    return () => {
      api.removeEventListener('sortChanged', onSortChanged);
    };
  }, [api, column]);

  const isSortAscending = sortDirection === ASC_ORDER;
  const isSortDescending = sortDirection === DESC_ORDER;

  const handleSort = (event: React.MouseEvent) => {
    if (enableSorting) {
      progressSort(event.shiftKey);
    }
  };

  return (
    <div className={styles.HeaderWrapper} onClick={handleSort}>
      <span className="ag-header-cell-text">{displayName}</span>

      {tooltipText && (
        <TooltipComponent title={tooltipText}>
          <span className={styles.TooltipIcon}>
            <TabLabelIcon isProvidedField={!isWarningTooltip} />
          </span>
        </TooltipComponent>
      )}

      {enableSorting && (
        <span className={styles.SortIcons}>
          {isSortAscending && <i className="ag-icon ag-icon-asc" />}
          {isSortDescending && <i className="ag-icon ag-icon-desc" />}
        </span>
      )}
    </div>
  );
};

export default HeaderWithTooltip;
